import operationalStatuses from './operationalStatuses';

function orderStatuses(status) {
	return operationalStatuses(status);
}

orderStatuses.cancelled = operationalStatuses.cancelled;
orderStatuses.draft = operationalStatuses.draft;
orderStatuses.ready = operationalStatuses.ready;
orderStatuses.planned = operationalStatuses.planned;
orderStatuses.loaded = operationalStatuses.loaded;
orderStatuses.unloaded = operationalStatuses.unloaded;

export default orderStatuses;